import { NgModule } from '@angular/core';
import { DeepakSpinnerTestComponent } from './deepak-spinner-test.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SimpleSpinnerComponent } from './circles/simple-spinner/simple-spinner.component';
import { InnerArcComponent } from './circles/inner-arc/inner-arc.component';
import { CommonModule } from '@angular/common';
import { DeepakSpinnerTestService } from './deepak-spinner-test.service';
import { OuterArcComponent } from './circles/outer-arc/outer-arc.component';
import { TwinInnerArcComponent } from './circles/twin-inner-arc/twin-inner-arc.component';
import { TwinOuterArcComponent } from './circles/twin-outer-arc/twin-outer-arc.component';
import { InnerOrbitingDotComponent } from './circles/inner-orbiting-dot/inner-orbiting-dot.component';
import { OuterOrbitingDotComponent } from './circles/outer-orbiting-dot/outer-orbiting-dot.component';
import { InnerSpiralComponent } from './circles/inner-spiral/inner-spiral.component';
import { DualSegmentComponent } from './circles/dual-segment/dual-segment.component';
import { DottedCircularComponent } from './circles/dotted-circular/dotted-circular.component';
import { RotatingBarComponent } from './circles/rotating-bar/rotating-bar.component';
import { RingComponent } from './circles/ring/ring.component';
import { SquareWaveComponent } from './shapes/square-wave/square-wave.component';
import { GlowingRingComponent } from './circles/glowing-ring/glowing-ring.component';
import { HalfRingComponent } from './circles/half-ring/half-ring.component';
import { IntersectingRingComponent } from './circles/intersecting-ring/intersecting-ring.component';
import { BalancingShapesComponent } from './shapes/balancing-shapes/balancing-shapes.component';
import { RotatingSliceComponent } from './shapes/rotating-slice/rotating-slice.component';
import { InnerFillArcComponent } from './circles/inner-fill-arc/inner-fill-arc.component';
import { RollingCircleComponent } from './circles/rolling-circle/rolling-circle.component';
import { OrbitingDotsComponent } from './circles/orbiting-dots/orbiting-dots.component';
import { DualPulsatingDotsComponent } from './shapes/dual-pulsating-dots/dual-pulsating-dots.component';
import { ExpandingDotsComponent } from './shapes/expanding-dots/expanding-dots.component';
import { RotatingDoubleSquareComponent } from './square/rotating-double-square/rotating-double-square.component';
import { ScatteredDiamondComponent } from './square/scattered-diamond/scattered-diamond.component';
import { PulsatingGridComponent } from './square/pulsating-grid/pulsating-grid.component';
import { ExpandingSquareComponent } from './square/expanding-square/expanding-square.component';
import { TiltedBarComponent } from './shapes/tilted-bar/tilted-bar.component';
import { BouncingDiamondComponent } from './shapes/bouncing-diamond/bouncing-diamond.component';
import { IntersectingTriangleComponent } from './shapes/intersecting-triangle/intersecting-triangle.component';
import { RotatingTriangleComponent } from './shapes/rotating-triangle/rotating-triangle.component';
import { BouncingSquareComponent } from './square/bouncing-square/bouncing-square.component';
import { CircleInsideSquareComponent } from './square/circle-inside-square/circle-inside-square.component';
import { VerticalBarsPulsationComponent } from './shapes/vertical-bars-pulsation/vertical-bars-pulsation.component';
import { FlippingParallelLinesComponent } from './shapes/flipping-parallel-lines/flipping-parallel-lines.component';
import { RisingBarsWithDotComponent } from './shapes/rising-bars-with-dot/rising-bars-with-dot.component';
import { DashedLineExpansionComponent } from './shapes/dashed-line-expansion/dashed-line-expansion.component';
import { BalancingCapsuleComponent } from './shapes/balancing-capsule/balancing-capsule.component';
import { LoadingBounceComponent } from './shapes/loading-bounce/loading-bounce.component';
import { ExpandingBlockComponent } from './shapes/expanding-block/expanding-block.component';
import { ArcOfDotsComponent } from './circles/arc-of-dots/arc-of-dots.component';
import { RotatingPieShapeComponent } from './circles/rotating-pie-shape/rotating-pie-shape.component';
import { CircularProgressComponent } from './circles/circular-progress/circular-progress.component';
import { BouncingDotsComponent } from './circles/bouncing-dots/bouncing-dots.component';
import { SpinWithBounceComponent } from './square/spin-with-bounce/spin-with-bounce.component';



@NgModule({
  declarations: [
    DeepakSpinnerTestComponent,
    SpinnerComponent,
    SimpleSpinnerComponent,
    InnerArcComponent,
    OuterArcComponent,
    TwinInnerArcComponent,
    TwinOuterArcComponent,
    InnerOrbitingDotComponent,
    OuterOrbitingDotComponent,
    InnerSpiralComponent,
    DualSegmentComponent,
    DottedCircularComponent,
    RotatingBarComponent,
    RingComponent,
    SquareWaveComponent,
    GlowingRingComponent,
    HalfRingComponent,
    IntersectingRingComponent,
    BalancingShapesComponent,
    RotatingSliceComponent,
    InnerFillArcComponent,
    RollingCircleComponent,
    OrbitingDotsComponent,
    DualPulsatingDotsComponent,
    ExpandingDotsComponent,
    RotatingDoubleSquareComponent,
    ScatteredDiamondComponent,
    PulsatingGridComponent,
    ExpandingSquareComponent,
    TiltedBarComponent,
    BouncingDiamondComponent,
    IntersectingTriangleComponent,
    RotatingTriangleComponent,
    BouncingSquareComponent,
    CircleInsideSquareComponent,
    VerticalBarsPulsationComponent,
    FlippingParallelLinesComponent,
    RisingBarsWithDotComponent,
    DashedLineExpansionComponent,
    BalancingCapsuleComponent,
    LoadingBounceComponent,
    ExpandingBlockComponent,
    ArcOfDotsComponent,
    RotatingPieShapeComponent,
    CircularProgressComponent,
    BouncingDotsComponent,
    SpinWithBounceComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DeepakSpinnerTestComponent,
    SpinnerComponent
  ]
})
export class DeepakSpinnerTestModule { }
